let isDev = process.env.NODE_ENV === 'development';
console.log(222, process.env.NODE_ENV);

let online = '/api/app/';

// online = 'https://www.testapi.shfsglobal.com/app/'

// isDev = false

if (window.SERVER_ONLINE) {
  online = window.SERVER_ONLINE;
}

export default {
  http: {
    base: isDev ? `http://127.0.0.1:9633/api/app/` : `${online}`,
  },
};
